// ** Initial user ability
export const initialAbility = [
  {
    manage: 'all',
  },
]

export const _ = undefined
